import { Typography } from '@mui/material';
import { memo } from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { HightlightedText, SearchJobsWithWhatsappWrapper } from './SearchJobsWithWhatsapp.styles';
import Button from '../../foundation/Button';
import CustomBR from '../../foundation/CustomBR';

export type SearchJobsWithWhatsappProps = any

// 📱

const show = true;

const SearchJobsWithWhatsapp = () => {
    if (!show) return null;

    return (
        <SearchJobsWithWhatsappWrapper>
            <HightlightedText>
                <Typography>🚀 חדש ומהפכני! חיפוש עבודה בקלות עם סוכן ה-AI שלנו – ישירות בוואטסאפ</Typography>
            </HightlightedText>
            <CustomBR />
            <Button onClick={() => {
                window.open('/go/whatsapp-chat', '_blank');
            }} variant="contained" style={{ backgroundColor: 'white', padding: '0.5rem 2.5rem' }}>
                <Typography color="primary" fontWeight="bold" display="flex" alignItems="center">
                    <WhatsAppIcon />&nbsp;&nbsp;מצא לי עבודה עכשיו
                </Typography>
            </Button>
        </SearchJobsWithWhatsappWrapper>
    );
};

export default memo(SearchJobsWithWhatsapp);
